"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.buttonPropTypes = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _automationHooks = require("@airportlabs/automation-hooks");
var _ButtonStyled = _interopRequireDefault(require("./ButtonStyled"));
var _helpers = require("../helpers");
var _excluded = ["children", "type", "as", "hoverTextColor", "hoverColor", "automationHook"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var defaultProps = {
  type: "button",
  size: "base",
  disabled: false
};

/** This component is used by all other Button components
 * it is not exported directly
 */

var buttonPropTypes = {
  /** The type of the button to render
   * @default: button
   */
  type: _propTypes["default"].oneOf(["submit", "button"]),
  /** Change the button fill and border style, color defaults to primary */
  variant: _propTypes["default"].oneOf(["filled", "filledShadowHover", "border", "transparent", "incognito", "shadow", "shadowHover"]),
  /** DEPRECATED: Width of the button. Use "w" */
  width: _propTypes["default"].string,
  /** Width of the button. When not passed in the button is full-width of its container */
  w: _propTypes["default"].string,
  /** DEPRECATED: Height of the button. Use "h" */
  height: _propTypes["default"].string,
  /** Allow a height for buttons, but make sure there's an extra wrapper around
   * the button content, so the content gets properly vertically aligned. Use
   * with extreme caution, as this will not allow for the button to grow in
   * size, so if text wraps on two lines, it will look bad. This is used mostly
   * for buttons that are next to inputs, and thus takes h="fieldsHeight" as a
   * valid prop.
   */
  h: _propTypes["default"].string,
  /** Control the color of the button's background when it's filled, or the border/text color when it's ghost; Defaults to: "primary" */
  color: _propTypes["default"].string,
  /** Control the hover color of the button's background when it's filled, or the border/text color when it's ghost or shadow
   * This will allow you to have a different hover color
   * By default buttons just darken the color for hover
   */
  hoverColor: _propTypes["default"].string,
  /** Control the color of the button's text
   */
  textColor: _propTypes["default"].string,
  /** Control the hover color of the button's text
   * This will allow you to avoid darkening the text on hover for shadow buttons
   */
  hoverTextColor: _propTypes["default"].string,
  /** This prop is passed directly to styled-component, and used to changed the rendered HTML tag to what is passed e.g. `a` for a link  */
  as: _propTypes["default"].any,
  /** When 'true' the button is disabled
   * default: false
   */
  disabled: _propTypes["default"].bool,
  /** Function triggered when the button is clicked */
  onClick: _propTypes["default"].func,
  /** Child elements for the button */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  /** Text Align */
  textAlign: _propTypes["default"].oneOf(["left", "center", "right"]),
  /** Hook used for automation testing */
  automationHook: _propTypes["default"].string
};
exports.buttonPropTypes = buttonPropTypes;
var Button = function Button(_ref) {
  var children = _ref.children,
    type = _ref.type,
    as = _ref.as,
    hoverTextColor = _ref.hoverTextColor,
    hoverColor = _ref.hoverColor,
    automationHook = _ref.automationHook,
    rest = _objectWithoutProperties(_ref, _excluded);
  var width = rest.width,
    height = rest.height;
  (0, _helpers.useDeprecate)({
    width: width,
    height: height
  }, "Button");
  return /*#__PURE__*/_react["default"].createElement(_ButtonStyled["default"], _extends({}, rest, {
    $hoverTextColor: hoverTextColor,
    $hoverColor: hoverColor,
    type: as ? null : type,
    as: as
  }, (0, _automationHooks.hook)(automationHook)), children);
};
Button.propTypes = buttonPropTypes;
Button.defaultProps = defaultProps;
var _default = Button;
exports["default"] = _default;